<template>
  <div class="bg-light">
    <img src="../assets/Banner.png" class="img-fluid icon">
  </div>
</template>

<script>
export default {
  name: 'Brand',
  data() {
    return {

    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icon{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Brand.vue